export default __webpack_public_path__ + "static/media/connect-vpn-1.0f14f981.png";